import React from 'react'
import {Grid, FormControl, InputLabel, TextField, FormHelperText} from '@material-ui/core'
import {TimePicker} from '@material-ui/pickers'
import moment from 'moment'

export default function WTextField({data, onChange, tabActive}) {
  const getTime = () => {
    let time = moment().toDate()
    let [hour, min, sec] = data.value.split(':')
    time.setHours(hour)
    time.setMinutes(min)
    time.setSeconds(sec)
    return time
  }
  return (
    <FormControl fullWidth variant="outlined" className="ap-textfield" style={{width: 320}}>
      <TimePicker
        label={data.name}
        inputVariant="outlined"
        value={getTime()}
        onChange={e => {
          onChange(
            e,
            data.key,
            moment(e)
              .local()
              .format('hh:mm:ss')
          )
        }}
      />
      <FormHelperText>
        {(() => {
          if (
            (tabActive === 'upcoming' && data.is_required) ||
            (tabActive === 'ongoing' && data.is_required_return)
          ) {
            return 'required*'
          } else {
            return 'optional'
          }
        })()}
      </FormHelperText>
    </FormControl>
  )
}
